import React from 'react';
import InputMask from 'react-input-mask';
import colors from '../../constants/color';
import materialUI from '../../material-UI';
import { Input } from './styles';

interface Props {
  value?: string;
  onChange: Function;
  type?: string;
  isError?: boolean;
  isDisabled?: boolean;
  placeholder?: string;
  color?: string;
  row?: number;
  multiline?: boolean;
  masked?: boolean;
}

const useStyles = materialUI.makeStyles({
  root: {
    '& fieldset': {
      borderRadius: 40,
    },
    '& .MuiFormLabel-root': {
      paddingLeft: 6,
    },
  },
  input: {
    color: colors.grey9,
  },
});

const inputCommon: React.FC<Props> = ({
  value, onChange, type, isDisabled, placeholder, color, row, multiline, isError, masked,
}) => (
  <Input
    style={{ color: color || '#fff' }}
    value={value}
    className={useStyles().root}
    variant="outlined"
    onChange={(event) => onChange(event.target.value)}
    type={type}
    error={isError || false}
    disabled={isDisabled}
    rows={row || 1}
    multiline={multiline || false}
    label={`${placeholder}`}
  >
    {masked && (
      <InputMask mask="(99) 99999-9999" />
    )}
  </Input>
);
export default inputCommon;
